import './card.css';
function Card(props) {
    return (
        <>
            <article className="ontime-card">{props.children}</article>
        </>
    );
}

export default Card;